import { createSlice } from "@reduxjs/toolkit";
import { NewEmployeeFinanceStoreProps } from "../finance/types";

const initialState: Partial<NewEmployeeFinanceStoreProps> = {
  emp_bonus_flag: "Y",
  emp_pay_status: "Y",
};
type FieldNames = keyof Partial<NewEmployeeFinanceStoreProps>;
const newEmpFinanceDtlReducer = createSlice({
  name: "finance",
  initialState: initialState,
  reducers: {
    setNewEmployeeFinanceDtl(
      state,
      action: { payload: { field: FieldNames; value: string } }
    ) {
      const { field, value } = action.payload;
      state[field] = value;
    },
  },
});

export default newEmpFinanceDtlReducer.reducer;

export const { setNewEmployeeFinanceDtl } = newEmpFinanceDtlReducer.actions;
